module.exports = __webpack_public_path__ + "img/20190628160601382.8f689ebf.png";